<script lang="ts">
import { SectionBlockType } from "@/apps/page/page.interfaces";
import { ToolAppTypes } from "@/shared/tool-app.types";

// TODO @Jabi: simplify this interface? or extract it if needed ?
interface SectionSelection {
    title: string;
    icon: object;
    tool?: ToolAppTypes;
    type?: SectionBlockType;
    createTitle?: string;
    emptyTitle?: string;
    emptySubtitle?: string;
    count?: number;
}
</script>

<script setup lang="ts">
import { PageSidebar } from "@easy/ui/page-components";
import { ButtonSecondaryIconSm, ButtonCloseXs } from "@easy/ui/buttons";
import { CardToggle } from "@easy/ui/cards";
import { ArrowLeftIcon } from "@easy/ui/icons";
import { computed, ref } from "vue";
import SectionCard from "./SectionCard.vue";
import AddBlock from "./block/AddBlock.vue";
import { useBlocks } from "@/apps/page/services/blocks/useBlocks";
import { useSections } from "@/apps/page/services/useSections";
import { useDragState } from "@/shared/utils/useDragState";
import AddToolList from "@/apps/page/project/sidebar/sections/tool/AddToolList.vue";

defineProps({
    toolProjects: {
        type: Object,
        default: () => ({}),
    },
});

const emit = defineEmits(["back"]);
const currentSection = ref<SectionSelection | undefined>(undefined);

const { getAllBlockTypes, blocks } = useBlocks();
const { getAllSectionTypes } = useSections();

// TODO: @Jabi: for now show only existing blocks (count > 0)
const allBlockTypes = computed(() => getAllBlockTypes().filter((block) => block.count > 0));
const allSectionTypes = computed(() => getAllSectionTypes());

const goBack = () => {
    emit("back");
};

const { isDragging, startDragging, resetDragState } = useDragState();

const openSection = (section: SectionSelection) => {
    resetDragState();
    currentSection.value = section;
};

function handleDragStart() {
    startDragging();
}
</script>

<template>
    <PageSidebar>
        <template #sidebarTitle>
            <div class="space-x-3">
                <ButtonSecondaryIconSm @click="goBack">
                    <ArrowLeftIcon />
                </ButtonSecondaryIconSm>
                <span>{{ $t("page.sections.add_section") }}</span>
            </div>
        </template>
        <template #sidebarMain>
            <CardToggle :title="$t('page.sections.standard_sections')">
                <div class="space-y-2">
                    <SectionCard
                        v-for="section in allBlockTypes"
                        :key="section.type"
                        :section="section"
                        :active="currentSection"
                        @open="openSection"
                    />
                </div>
            </CardToggle>
            <CardToggle :title="$t('page.sections.app_sections')">
                <div class="space-y-2">
                    <SectionCard
                        v-for="section in allSectionTypes"
                        :key="section.title"
                        :section="section"
                        :active="currentSection"
                        @open="openSection"
                        :tool="section.tool"
                    />
                </div>
            </CardToggle>

            <!-- SUB LEFT onRIGHT DRAWER -->

            <div
                class="absolute inset-0 lg:!left-[320px] lg:w-[320px] top-0 z-20 ct-bg-1"
                :class="{ '-translate-x-[9999px]': isDragging || !currentSection }"
                @mouseleave="currentSection = null"
            >
                <div class="flex flex-col h-full border-r ct-border-2">
                    <div
                        class="flex-shrink-0 flex items-center space-x-2 px-6 h-[64px] border-b ct-border-2"
                    >
                        <div
                            class="ct-text-1 text-lg lg:text-xl flex items-center justify-between w-full"
                        >
                            <span>{{ currentSection?.title }}</span>
                            <ButtonCloseXs @click="currentSection = undefined" />
                        </div>
                    </div>
                    <div class="flex flex-col h-full overflow-y-auto">
                        <AddBlock
                            :blocks="blocks"
                            :current-section="currentSection"
                            @dragStart="handleDragStart"
                        />
                        <AddToolList
                            v-if="currentSection && currentSection.tool"
                            :projects="toolProjects[currentSection.tool]"
                            :tool="currentSection.tool"
                            @dragStart="startDragging()"
                        />
                    </div>
                </div>
            </div>
        </template>
    </PageSidebar>
</template>
